<template>
  <v-container>
    <material-card
      color="blue"
      title="Cupons"
      text="Cupons de desconto"
      v-if="!loading"
    >
      <v-container>
        <v-layout>
          <v-flex xs12 md6 lg6 class="text-lg-left">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 lg6 class="text-xs-right">
            <v-btn dark color="blue" @click.prevent="createCoupon"
              >Adicionar Cupom</v-btn
            >
          </v-flex>
        </v-layout>

        <v-data-table
          :headers="headers"
          :items="coupons"
          :search="search"
          :pagination.sync="pagination"
        >
          <template v-slot:progress>
            <v-progress-linear color="blue" v-if="loading"></v-progress-linear>
          </template>
          <template v-slot:items="props">
            <td>{{ props.item.created_at | formatarDateTime }}</td>
            <!-- <td>{{ props.item.coupon }}</td> -->
            <td>
              <v-edit-dialog
                :return-value.sync="props.item.coupon"
                lazy
                @save="save(props.item.id, 'coupon', coupon_text)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                {{ props.item.coupon }}
                <template v-slot:input>
                  <v-text-field
                    v-model="coupon_text"
                    :rules="[
                      (v) => !!v || 'Por favor, preencher o nome do cupom.',
                      (v) =>
                        (v.length >= 5 && v.length <= 25) ||
                        'Por favor, o nome do cupom deve ter entre 5 e 15 caracteres.',
                      (v) =>
                        !!duplicateCoupon(v) ||
                        'Esse cupom já existe cadastrado',
                    ]"
                    label="Editar"
                    single-line
                    :value="props.item.coupon"
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <!-- <td class="text-xs-right">{{ props.item.status }}</td> -->
            <td class="text-xs-right">{{ props.item.start_at }}</td>
            <td class="text-xs-right">{{ props.item.expire_at }}</td>
            <!-- <td class="text-xs-right">{{ props.item.discount }}</td> -->
            <td class="text-xs-right">
              <v-edit-dialog
                :return-value.sync="props.item.discount"
                lazy
                @save="save(props.item.id, 'discount', coupon_discount)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                {{ props.item.discount }}
                <template v-slot:input>
                  <v-text-field
                    v-model.number="coupon_discount"
                    :rules="discountRules"
                    label="Editar"
                    single-line
                    :value="props.item.discount"
                    counter
                    type="number"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="text-xs-right">
              <v-edit-dialog
                :return-value.sync="props.item.limit"
                lazy
                @save="save(props.item.id, 'limit', coupon_limit)"
                @cancel="cancel"
                @open="open"
                @close="close"
              >
                {{ props.item.limit }}
                <template v-slot:input>
                  <v-text-field
                    v-model.number="coupon_limit"
                    :rules="limitRules"
                    label="Editar"
                    single-line
                    :value="props.item.limit"
                    counter
                    type="number"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="text-xs-right">{{ props.item.used }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                small
                class="mr-2"
                @click="activate(props.item.id, !props.item.activated)"
                color="green"
                v-if="props.item.activated"
              >
                toggle_on
              </v-icon>
              <v-icon
                small
                class="mr-2"
                @click="activate(props.item.id, !props.item.activated)"
                color="red"
                v-else
              >
                toggle_off
              </v-icon>
            </td>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              Sua busca para "{{ search }}" não encontrou resultados.
            </v-alert>
          </template>
          <template v-slot:no-data> Não há cupons cadastrados </template>
        </v-data-table>
      </v-container>
    </material-card>
    <coupon-form />
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import CouponForm from "../../components/marketing/CouponForm.vue";
import { updateCouponField } from "../../services/marketing/coupon";
import { eventBus } from "../../main";
export default {
  components: { CouponForm },
  computed: {
    ...mapState("marketing", ["coupons", "loading"]),
  },
  data: () => ({
    dialog: false,
    search: "",
    coupon_text: "",
    coupon_discount: "",
    discountRules: [
      (v) => !!v || "Por favor, preencher o valor de desconto do cupom.",
      (v) => v > 0 || "Por favor, o cupom precisa gerar desconto.",
    ],
    coupon_limit: 0,
    limitRules: [
      (v) => !!v || "Por favor, preencher o valor de desconto do cupom.",
    ],
    headers: [
      {
        text: "Data de Criação",
        align: "left",
        value: "created_at",
        sortable: false,
      },
      {
        text: "Cupom",
        align: "left",
        value: "coupon",
        sortable: false,
      },
      //   { text: 'Status', value: 'status' },
      { text: "Inicio", value: "expire_at", sortable: false },
      { text: "Data de Validade", value: "expire_at", sortable: false },
      { text: "Valor de Desconto (R$)", value: "discount", sortable: false },
      { text: "Limite de Uso", value: "limit", sortable: false },
      { text: "Qtde de Uso", value: "used", sortable: false },
      { text: "", value: "activated", sortable: false },
    ],
    snack: false,
    snackColor: "",
    snackText: "",
    pagination: {
      rowsPerPage: 25, // -1 for All",
    },
  }),
  mounted() {
    if (!this.coupons || this.coupons.length <= 0) {
      this.getCoupons();
    }
  },
  methods: {
    ...mapActions("marketing", ["getCoupons", "updateCouponText"]),
    createCoupon() {
      eventBus.$emit("dialog_cupomform", true);
    },
    duplicateCoupon(val) {
      if (!val) return;
      else if (!this.coupons) return;
      let has = this.coupons.filter((el) => el.coupon === val);
      return has.length <= 0;
    },
    save(id, field, data) {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
      updateCouponField(id, field, data);
    },
    cancel() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    open() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    close() {
      console.log("Dialog closed");
    },
    activate(id, value) {
      console.log("value: ", value);
      updateCouponField(id, "activated", value);
    },
  },
};
</script>
